import { KEY_CODES } from 'constants/keyboard';

const EDITABLE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
const IME_COMPOSITION_KEY_CODE = 229;

const getSpecialKeyCode = key => {
  switch (key) {
    case 'Enter':
      return KEY_CODES.ENTER;
    case 'Escape':
      return KEY_CODES.ESC;
    case 'Backspace':
      return KEY_CODES.BACKSPACE;
    default:
  }
};

const isKeyModified = e => {
  return e.metaKey || e.ctrlKey || e.altKey || e.shiftKey;
};

export const getKeyCode = e => {
  return e.which || e.keyCode || getSpecialKeyCode(e.key);
};

export const getPressedKey = e => {
  if (isKeyModified(e)) {
    return null;
  }

  return getKeyCode(e);
};

export const isEditableTarget = target => {
  if (!target) {
    return false;
  }

  if (EDITABLE_TAGS.includes(target.tagName)) {
    return true;
  }

  return !!target.isContentEditable;
};

export const isPrintableCharacter = e => {
  if (e.isComposing || e.keyCode === IME_COMPOSITION_KEY_CODE) {
    return false;
  }

  if (e.ctrlKey || e.metaKey || e.altKey) {
    return false;
  }

  return e.key?.length === 1;
};
